<section class="{{'timeline__section timeline__section--' + timelineSection.sectionType}}">

  @if (anchor != '') {
    <a [id]="anchor" class="anchor"></a>
  }

  @if (timelineSection.sectionType != 'milestone') {
    <div class="timeline__date">
      <div class="timeline__date--month">{{milestoneLabel}}</div>
    </div>
  }

  <div class="{{'section__icon section__icon--' + timelineSection.sectionType}}"
    [ngClass]="{'section__icon--large': timelineSection.sectionType == 'milestone'}">
    {{timelineSection.sectionType == 'milestone' ? milestoneLabel : ''}}
  </div>
  @if (showOpenButton()) {
    <div [ngClass]="openButtonClass()" class="section__close-btn" (click)="openSection(timelineSection)"></div>
  }
  <div class="section__body">
    <h2 class="section__title">{{sectionTitle}}</h2>
    <ng-template *timelineSectionSelector="timelineSection"></ng-template>
  </div>

</section>
